import { Button, IconAdd } from '@leaftrade/leaftrade-component-library';
import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleQuickOrderAddModal } from '../../../store/actions/storefrontActions';
import QuickOrderLocationSelect from '../QuickOrderLocationSelect';
import { QuickOrderTableHeaderActionsContainer } from './QuickOrderTable.styles';

const QuickOrderTableHeaderActions = () => {
  const dispatch = useDispatch();

  return (
    <QuickOrderTableHeaderActionsContainer>
      <QuickOrderLocationSelect />
      <Button
        onClick={() => dispatch(toggleQuickOrderAddModal({ isOpen: true }))}
        startIcon={<IconAdd />}
        variant='primary'
      >
        Add Item
      </Button>
    </QuickOrderTableHeaderActionsContainer>
  );
};

export default QuickOrderTableHeaderActions;
